import { isBrowser } from 'Shared/device-type';
import * as localStorage from 'Shared/local-storage';
const LOCALSTORAGE_KEY = 'search_history';
const HISTORY_LENGTH = 30;
const searchHistory = deserialize();
export function find(searchWords) {
    searchWords = searchWords.filter(w => w.trim().length > 1);
    if (!searchWords.length) {
        return searchHistory.slice();
    }
    return searchHistory.slice().filter(item => {
        return !!searchWords
            .filter(w => w.length > 1)
            .find(searchWord => item.toLowerCase().indexOf(searchWord.toLowerCase()) !== -1);
    });
}
export function add(item) {
    item = item.trim();
    if (item === '' || searchHistory.find(s => s === item)) {
        return;
    }
    searchHistory.unshift(item);
    if (searchHistory.length > HISTORY_LENGTH) {
        searchHistory.splice(HISTORY_LENGTH);
    }
    serialize();
}
function serialize() {
    if (!isBrowser()) {
        return;
    }
    localStorage.set(LOCALSTORAGE_KEY, searchHistory);
}
function deserialize() {
    if (!isBrowser()) {
        return [];
    }
    return (localStorage.get(LOCALSTORAGE_KEY) || []);
}
